<div class="container">
    <div class="row">
        <img src="/assets/images/octopus-logo-white.png" alt="Octopus Header" class="welcome-img mx-auto" />
    </div>
    <div class="row">
        <div class="col-md-12 col-lg-12 col-sm-12 text-center mb-4">
            <p class="my-4">
                It looks like your application is incomplete. Please contact
                support to continue with your application.
            </p>
            <p class="my-4">
                If you have any questions or concerns, you may reach Octopus
                by visiting
                <a href="https://playoctopus.com/help" target="_blank" id="signup-info-help-link">playoctopus.com/help
                </a>
                or by calling (240) 366-5877 (Monday - Friday).
            </p>
        </div>
    </div>
</div>
